import { UpdateVersions } from '../../modules/UpdateManagement/types';

type prop = {
  versionsObject: UpdateVersions | undefined;
};

function ChangeVersionForm({ versionsObject }: prop) {
  if (!versionsObject) {
    return (
      <div>
        <h1>error:</h1>
        <h1>could not find a suitable version to delete</h1>
      </div>
    );
  }

  return (
    <form className="mt-4 flex flex-col">
      <section>
        <p className="font-semibold text-lg mb-2 text-red-600">Are you sure you want to delete</p>
        <p className="text-lg font-semibold">{`Application: ${versionsObject.applicationName}`}</p>
        <p className="text-lg font-semibold">{`Version: ${versionsObject.version}`}</p>
      </section>
    </form>
  );
}

export default ChangeVersionForm;
